import ShiftUpdateMenuOption from './shift-update-menu-option'

export default ShiftUpdateMenuOption
